import React from 'react';
import { connect } from 'react-redux';
import { updateInfluencer } from '../actions';
import ReactDOMServer from 'react-dom/server';
import RaisedButton from 'material-ui/RaisedButton';

import DropzoneComponent from 'react-dropzone-component';
import 'react-dropzone-component-css';
import 'dropzone-css';
import Config from '../Config';
import LoadingOverlay from '../components/LoadingOverlay';

import css from './avatar-uploader.css';
import MdFileUpload from 'react-icons/lib/md/file-upload';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AdminTheme from '../theme';
import { Card, CardActions, CardTitle, CardText } from 'material-ui/Card';

const dropZoneComponentConfig = scope => ({
  iconFiletypes: ['.csv', '.xls', '.xlsx'],
  showFiletypeIcon: true,
  postUrl: `${Config.apiEndpoint}/${scope}/import`
});

const dropZoneMessage = props =>
  ReactDOMServer.renderToStaticMarkup(
    <MuiThemeProvider muiTheme={muiTheme}>
      {props.children}
    </MuiThemeProvider>
  );

const muiTheme = getMuiTheme(AdminTheme);

class FileUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { processing: false, progress: 0, complete: false };
  }

  eventHandlers = () => ({
    sending: () => {
      this.setState({ processing: true });
      this.props.onUpload();
    },
    success: (file, responseText) => {
      this.setState({ processing: false });
      this.props.onComplete(responseText);
     },
    error: (file, response) => {
      this.setState({ processing: false })
      this.props.onError(response);
    },
  });

  dropZoneConfig = () => ({
    uploadMultiple: false,
    dictDefaultMessage: dropZoneMessage(this.props),
    createImageThumbnails: false,
    previewTemplate: '<div></div>',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
    },
  });

  render() {
    return (
      <div>
        <DropzoneComponent
          config={dropZoneComponentConfig(this.props.scope)}
          djsConfig={this.dropZoneConfig()}
          eventHandlers={this.eventHandlers()}
        />
        <LoadingOverlay loading={this.state.processing} />
      </div>
    );
  }
}

export default connect()(FileUploader);



/** WEBPACK FOOTER **
 ** ./components/FileUploader.js
 **/